import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
//import Checkbox from '@material-ui/core/Checkbox';

import IconButton from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import BulkCustomerContainer from '../../containers/logistics/BulkCustomer';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
import BulkFormulasContainer from '../../containers/BulkFormulas';
import QuickbooksContainer from '../../containers/accounting/Quickbooks';

import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
import Contacts from '../../components/form/Contacts';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';

//-FMP form
import FMPTextField from '../../components/ui/FMPTextField';

//- Pure form
import FMPSelect from '../../components/pureForm/FMPSelect';
import FMPBulkFormulaSelect from '../../components/pureForm/FMPBulkFormulaSelect';
import FMPSwitch from '../../components/pureForm/FMPSwitch';
import FMPCheckbox from '../../components/pureForm/FMPCheckbox';
import FMPText from '../../components/pureForm/FMPText';

import { validateEmail } from '../../libs/utility';

//import Switch from '@material-ui/core/Switch';

const styles = (theme) => {
	return {
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		formControl: {
			width: '100%',
			margin: '10px 0',
		},
		inputGroup: {
			borderLeft: '5px solid #ccc',
			marginTop: 10,
			marginBottom: 20,
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
		},
	};
};
const formFields = {
	name: '',
	offloadTerminals: [
		{
			productType: 'etoh',
			terminalId: '',
			offloadNumber: '',
			clearedCarrierMap: {},
			note: '',
		},
	],
	deliveryEmails: [''],
	invoiceEmails: [''],
	invoiceQuickbooksCustomerId: '',
	bulkFormulaId: '',
	requirePricingPerInvoice: false,
	billNetGallonsFromOffload: false,
	contacts: [
		{
			name: '',
			title: '',
			officePhoneNumber: '',
			mobilePhoneNumber: '',
			email: '',
			note: '',
		},
	],
};

// XXX Update does not work

class SaveBulkCustomer extends Component {
	constructor(props) {
		super(props);
		const bulkCustomerId = _.get(this.props, ['match', 'params', 'bulkCustomerId']);

		this.state = {
			bulkCustomerId: bulkCustomerId ? parseInt(bulkCustomerId, 10) : undefined,
			isUpdate: bulkCustomerId,
			formFieldError: {},
		};
		this.state = _.merge(this.state, formFields);
	}

	componentDidMount() {
		const {
			bulkCustomer,
			getBulkCustomer,
			carriers,
			searchCarriers,
			terminals,
			searchTerminals,
			quickbooksCustomers,
			searchQuickbooksCustomers,
			bulkFormulas,
			searchBulkFormulas,
		} = this.props;

		const { isUpdate, bulkCustomerId } = this.state;

		if (_.isEmpty(carriers)) {
			searchCarriers();
		}
		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
		if (_.isEmpty(bulkFormulas)) {
			searchBulkFormulas();
		}

		if (_.isEmpty(quickbooksCustomers)) {
			searchQuickbooksCustomers();
		}

		if (!isUpdate) {
			return;
		}

		if (!bulkCustomer) {
			getBulkCustomer({
				params: { bulkCustomerIds: [bulkCustomerId] },
			});
		} else {
			const newState = this.getFormValuesFromBulkCustomer({ bulkCustomer });
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps) {
		if (_.isUndefined(prevProps.bulkCustomer) && !_.isUndefined(this.props.bulkCustomer)) {
			const newState = this.getFormValuesFromBulkCustomer({
				bulkCustomer: this.props.bulkCustomer,
			});
			this.setState(newState);
		}
	}

	getFormValuesFromBulkCustomer = (props) => {
		const { bulkCustomer } = props;
		if (!bulkCustomer) {
			return;
		}

		const formValues = {};
		[
			'name',
			'offloadTerminals',
			'contacts',
			'deliveryEmails',
			'invoiceEmails',
			'invoiceQuickbooksCustomerId',
			'requirePricingPerInvoice',
			'billNetGallonsFromOffload',
			'bulkFormulaId',
		].forEach((key) => {
			if (_.isNil(bulkCustomer[key])) {
				return;
			}
			formValues[key] = bulkCustomer[key];
		});
		return formValues;
	};

	addInput = (arrayName) => {
		const val = _.cloneDeep(formFields[arrayName]);
		this.setState({ [arrayName]: this.state[arrayName].concat(val) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	handlePureChange = _.debounce((value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		if (path === 'requirePricingPerInvoice') {
			newState.bulkFormulaId = '';
		}

		this.setState(newState);
	});

	onChange(event, fieldName, index, attr) {
		if (!_.isNumber(index)) {
			this.setState({ [fieldName]: event.target.value });
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			this.setState({ [fieldName]: inputs });
		}
	}

	handleSave = () => {
		const { addBulkCustomer, updateBulkCustomer, showErrors } = this.props;

		//- Required fields
		const formFieldError = {};
		[{ fieldName: 'name', display: 'Name' }].forEach((s) => {
			if (!this.state[s.fieldName]) {
				formFieldError[s.fieldName] = `${s.display} is required`;
			}
		});

		//- Get all the values and do individual checks
		const {
			name,
			offloadTerminals,
			deliveryEmails,
			contacts,
			isUpdate,
			bulkCustomerId,
			invoiceQuickbooksCustomerId,
			bulkFormulaId,
			invoiceEmails,
			requirePricingPerInvoice,
			billNetGallonsFromOffload,
		} = this.state;

		if (!_.isEmpty(invoiceEmails)) {
			invoiceEmails.forEach((email, i) => {
				if (validateEmail(email)) {
					return;
				}
				_.set(formFieldError, ['invoiceEmails', i], 'Invalid characters in email');
			});
		}

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		//- Lock and load
		const params = {
			name,
			offloadTerminals,
			deliveryEmails,
			contacts,
			invoiceQuickbooksCustomerId,
			invoiceEmails,
			requirePricingPerInvoice,
			billNetGallonsFromOffload,
		};

		if (_.isNumber(bulkFormulaId)) {
			params.bulkFormulaId = bulkFormulaId;
		}

		if (!isUpdate) {
			addBulkCustomer({ params });
		} else {
			params.bulkCustomerId = bulkCustomerId;
			updateBulkCustomer({ params });
		}
	};

	_gf = (path) => {
		return {
			path,
			value: this.getValue(path),
			error: this.getError(path),
			onChange: this.handlePureChange,
			md: 6,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const {
			classes,
			bulkCustomer,
			carriers,
			terminals,
			quickbooksCustomers,
			bulkFormulas,
		} = this.props;

		const {
			isUpdate,
			//bulkCustomerId,
			contacts,
			requirePricingPerInvoice,
			//formFieldError,
		} = this.state;

		if (!terminals.length || !carriers.length || !bulkFormulas.length) {
			return <div>Fetching information...</div>;
		}

		if (isUpdate && !bulkCustomer) {
			return <div>Bulk customer information...</div>;
		}
		const verb = isUpdate ? 'Update' : 'Add';

		const { invoiceQuickbooksCustomerId } = this.state;
		let selectedQuickbooksCustomer;

		const quickbooksCustomerOptions = _.sortBy(quickbooksCustomers, 'DisplayName').map(
			(quickbooksCustomer) => {
				const { quickbooksCustomerId, DisplayName, ParentRef } = quickbooksCustomer;
				let display = DisplayName;
				if (ParentRef) {
					display = <div style={{ paddingLeft: 20 }}>{DisplayName}</div>;
				}

				if (invoiceQuickbooksCustomerId === quickbooksCustomerId) {
					selectedQuickbooksCustomer = quickbooksCustomer;
				}

				return {
					value: quickbooksCustomerId,
					display,
				};
			}
		);

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								{verb} Bulk Customer
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>
						<div className={classes.sectionHeader}>Customer Info</div>

						<FMPText {...this._gf('name')} label={'Customer Name'} />

						<div className={classes.sectionHeader}>Cleared Terminals</div>
						{this.renderOffloadTerminals()}

						<Contacts contacts={contacts} controller={this} />

						<FMPRegionHeader label={'Invoice Info'} />
						<div className={classes.sectionHeader}>Pricing</div>

						<FMPSwitch
							path={`billNetGallonsFromOffload`}
							label={'Bill net gallons from offload (not from pickup).'}
							value={this.getValue('billNetGallonsFromOffload')}
							error={this.getError('billNetGallonsFromOffload')}
							onChange={this.handlePureChange}
							md={6}
						/>

						<FMPSwitch
							path={`requirePricingPerInvoice`}
							label={'No bulk formula. Require pricing per invoice'}
							value={this.getValue('requirePricingPerInvoice')}
							error={this.getError('requirePricingPerInvoice')}
							onChange={this.handlePureChange}
							md={6}
						/>

						<FMPBulkFormulaSelect
							path={'bulkFormulaId'}
							onChange={this.handlePureChange}
							value={this.getValue('bulkFormulaId')}
							error={this.getError('bulkFormulaId')}
							bulkFormulas={bulkFormulas}
							md={6}
							disabled={requirePricingPerInvoice}
						/>

						<div className={classes.sectionHeader}>Link to Quickbooks</div>

						{_.isEmpty(quickbooksCustomerOptions) && (
							<div>Still fetching quickbooks customers...</div>
						)}

						{!_.isEmpty(quickbooksCustomerOptions) && (
							<FMPSelect
								label={`Quickbooks Customer`}
								path={'invoiceQuickbooksCustomerId'}
								onChange={this.handlePureChange}
								value={this.getValue('invoiceQuickbooksCustomerId')}
								error={this.getError('invoiceQuickbooksCustomerId')}
								md={6}
								options={quickbooksCustomerOptions}
							/>
						)}

						{!selectedQuickbooksCustomer && <div>Please select a valid quickbooks customer</div>}

						<div className={classes.sectionHeader}>Invoice Emails</div>
						{this.state.invoiceEmails.map((email, i) => {
							const path = `invoiceEmails.${i}`;
							return (
								<Grid key={i} container spacing={3}>
									<FMPText {...this._gf(path)} label={`Email ${i + 1}`} md={5} contained={false} />

									<Grid item xs={1}>
										<IconButton
											color="primary"
											className={classes.button}
											onClick={() => this.removeInput('invoiceEmails', i)}
										>
											<DeleteIcon />
										</IconButton>
									</Grid>
								</Grid>
							);
						})}

						<Button
							variant="contained"
							className={classes.addInputButton}
							onClick={() => this.addInput('invoiceEmails')}
						>
							ADD INVOICE EMAIL
						</Button>

						<div style={{ textAlign: 'right' }}>
							<Button
								variant="contained"
								color="primary"
								className={classes.submitButton}
								onClick={this.handleSave}
							>
								{verb} Bulk Customer
							</Button>
						</div>
					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderOffloadTerminals() {
		const { terminals, classes, carriers } = this.props;

		const { offloadTerminals } = this.state;

		return (
			<div>
				{offloadTerminals.map((offloadTerminal, i) => {
					const makeOnChange = (index, name) => {
						return (e) => {
							this.onChange(e, 'offloadTerminals', index, name);
						};
					};

					if (!offloadTerminal.clearedCarrierMap) {
						offloadTerminal.clearedCarrierMap = {};
					}

					return (
						<Grid key={i} container spacing={3} className={classes.inputGroup}>
							<Grid item xs={12} md={6}>
								{this.renderProductSelect({
									id: `offloadTerminalProduct${i}`,
									productType: offloadTerminal.productType,
									onChange: makeOnChange(i, 'productType'),
								})}

								{this.renderTerminalSelect({
									id: `offloadTerminal${i}`,
									terminalId: offloadTerminal.terminalId,
									terminals,
									onChange: makeOnChange(i, 'terminalId'),
								})}

								<FMPTextField
									name={'offloadTerminals'}
									attr={'offloadNumber'}
									index={i}
									label={'Offload Number'}
									controller={this}
									md={12}
								/>

								<FMPTextField
									name={'offloadTerminals'}
									attr={'note'}
									index={i}
									label={'Notes'}
									controller={this}
									md={12}
								/>
							</Grid>

							<Grid item xs={12} md={5}>
								{this.renderClearedCarriers({
									i,
									carriers,
									clearedCarrierMap: offloadTerminal.clearedCarrierMap,
								})}
							</Grid>

							<Grid item xs={12} md={1}>
								{this.state.offloadTerminals.length >= 2 && (
									<IconButton
										color="primary"
										aria-label="Delete"
										onClick={() => this.removeInput('offloadTerminals', i)}
									>
										<DeleteIcon />
									</IconButton>
								)}
							</Grid>
						</Grid>
					);
				})}

				<Grid container spacing={3}>
					<Grid item xs={12} md={6}>
						<Button
							variant="contained"
							className={classes.addInputButton}
							onClick={() => this.addInput('offloadTerminals')}
						>
							ADD ANOTHER TERMINAL
						</Button>
					</Grid>
				</Grid>
			</div>
		);
	}

	/*
	renderDeliveryEmails () {
		const {classes} = this.props;

		return (<Fragment>
			<div className={classes.sectionHeader}>Delivery Emails</div>
			{this.state.deliveryEmails.map((email, i) => {
				return (
					<Grid key={i} container spacing={3}>
						<FMPTextField
							name={'deliveryEmails'}
							index={i}
							label={`Email ${i + 1}`}
							controller={this}
							md={5}
							contained={false}
						/>
						<Grid item xs={1}>
							<IconButton
								color="primary"
								className={classes.button}
								onClick={() => this.removeInput('deliveryEmails', i)}
							>
								<DeleteIcon/>
							</IconButton>
						</Grid>
					</Grid>
				);
			})}

			<Button
				variant="contained"
				className={classes.addInputButton}
				onClick={() => this.addInput('deliveryEmails')}
			>
				ADD DELIVERY EMAIL
			</Button>

		</Fragment>);
	}
	*/

	renderProductSelect({ id, productType, onChange }) {
		const products = [
			{ type: 'etoh', display: 'Ethanol' },
			{ type: 'unleaded', display: 'Unleaded' },
		];
		return (
			<Grid spacing={2} container>
				<Grid item xs={12} md={12}>
					<FormControl fullWidth={true}>
						<InputLabel htmlFor={id}>Product Type</InputLabel>
						<Select value={productType} onChange={onChange} input={<Input name={id} id={id} />}>
							{products.map((item) => {
								return (
									<MenuItem key={item.type} value={item.type}>
										{item.display}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
		);
	}

	renderTerminalSelect({ id, terminalId, terminals, onChange }) {
		return (
			<Grid spacing={2} container>
				<Grid item xs={12} md={12}>
					<FormControl fullWidth={true}>
						<InputLabel htmlFor={id}>Terminal</InputLabel>
						<Select value={terminalId} onChange={onChange} input={<Input name={id} id={id} />}>
							{terminals.map((item) => {
								return (
									<MenuItem key={item.terminalId} value={item.terminalId}>
										{item.name}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
		);
	}

	renderClearedCarriers({ carriers, clearedCarrierMap, i }) {
		return (
			<FormControl component="fieldset">
				<FormLabel component="legend">Cleared Carriers</FormLabel>
				<FormGroup>
					{carriers.map((carrier) => {
						const { carrierId, name } = carrier;

						const path = `offloadTerminals.${i}.clearedCarrierMap.${carrierId}`;

						return (
							<FMPCheckbox
								key={`cid${carrierId}`}
								path={path}
								label={name}
								value={`${carrierId}`}
								checked={!!clearedCarrierMap[carrierId]}
								onChange={this.handlePureChange}
							/>
						);

						/*
						return (<FormControlLabel
							key={`cid${carrierId}`}
							control={
								<Checkbox
									color="primary"
									style={{height: 40}}
									onChange={e =>
										this.handleChange(e,
											['offloadTerminals', i, 'clearedCarrierMap', carrierId]
										)
									}
									value={`${carrierId}`}
								/>
							}
							label={name}
						/>);
						*/
					})}
				</FormGroup>
			</FormControl>
		);
	}
}

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

SaveBulkCustomer.propTypes = {
	getBulkCustomer: PropTypes.func.isRequired,
	bulkCustomer: PropTypes.object,
	addBulkCustomer: PropTypes.func.isRequired,
	updateBulkCustomer: PropTypes.func.isRequired,

	searchCarriers: PropTypes.func.isRequired,
	carriers: PropTypes.array,

	searchBulkFormulas: PropTypes.func.isRequired,
	bulkFormulas: PropTypes.array,

	searchTerminals: PropTypes.func.isRequired,
	terminals: PropTypes.array,

	searchQuickbooksCustomers: PropTypes.func,
	quickbooksCustomers: PropTypes.array,

	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	BulkCustomerContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
	QuickbooksContainer,
	BulkFormulasContainer,
])(SaveBulkCustomer);
